import React from "react";
import { ParallaxProvider } from "react-scroll-parallax";
/* eslint import/first: off */
require("smoothscroll-polyfill").polyfill();
import { TransitionGroup } from "react-transition-group";
import R from "ramda";
import QS from "query-string";
import styles from "./App.styl";
import api from "./api-client";
import Modal from "./components/modal/Modal";
import ZipWrapper from "./components/forms/ZipInput/ZipWrapper";
import CarouselWrapper from "./components/carousel/CarouselWrapper";
import Members from "./components/members/Members";
import TopSection from "./components/static/TopSection";
import ThreeColumns from "./components/static/ThreeColumns";
import ImageCallout from "./components/static/ImageCallout";
import Act from "./components/static/Act";
//import Ambassadors from './components/static/Ambassadors';
import VideoBlock from "./components/static/VideoBlock";
import CTA from "./components/static/CTA";
//import CelebVideo from './components/static/CelebVideo';
//import OneAct from './components/static/OneAct';
import Timeline from "./components/timeline/Timeline";
import Email from "./components/forms/email/Email";
import Call from "./components/forms/call/Call";
import Bills from "./components/static/Bills";
import OneActHeader from "./components/static/OneActHeader";
import OneActFooter from "./components/static/OneActFooter";
import TopTitle from "./components/static/TopTitle";
import Button from "./components/button/Button";

let isInArray = (value, array) => {
  return array.indexOf(value) > -1;
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      zip: "",
      //state: '',
      //city: '',
      //streetAddress: '',
      loading: false,
      congressMembers: [],
      showModal: false,
      contactType: null,
      selectedMembers: [],
      selectedIDs: [],
      allIDs: [],
      emailedMembers: [],
      calledMembers: [],
      showThanks: false,
      zipError: false,
      sendEmailInputError: false,
      emailLoading: false,
      fullName: "",
      emailAddress: "",
      cid: "",
      ms: "",
      emailSentLoading: false
    };

    this.findMembersByZip = this.findMembersByZip.bind(this);
    this.findMembersByAddress = this.findMembersByAddress.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.setContactType = this.setContactType.bind(this);
    this.setSelectedMembers = this.setSelectedMembers.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    this.doneCalling = this.doneCalling.bind(this);
    this.clearZipError = this.clearZipError.bind(this);
    this.scrollToAnimals = this.scrollToAnimals.bind(this);
  }

  componentDidMount() {
    let path = window.location.search;
    let params = QS.parse(path);
    if (params) {
      this.setState({
        cid: params.cid,
        ms: params.ms
      });
    }
  }

  findMembersByZip = zip => {
    this.setState({
      loading: true,
      zip: zip
    });

    api.members({ zip }).then(response => {
      const congressMembers = response.data.members;
      if (congressMembers.length === 0) {
        this.setState({
          zipError: true,
          showModal: false,
          loading: false
        });
      } else if (congressMembers.length > 3) {
        this.setState({
          congressMembers,
          loading: false,
          showModal: false,
          zipError: false
        });
      } else {
        let state = response.data.members[0].state;
        this.setState({
          congressMembers,
          loading: false,
          showModal: true,
          zipError: false,
          state: state
        });
      }
    });
  };

  findMembersByAddress = address => {
    this.setState({
      loading: true,
      zip: address.zip
      //streetAddress: address.street,
      //city: address.city
    });

    //let addressString = `${address.street} ${address.zip} ${address.city}`;

    api
      .location({ postal_code: `${address.zip}` })
      .then(response => {
        if (response.data.latlon.latitude) {
          let lat = response.data.latlon.latitude;
          let lng = response.data.latlon.longitude;
          // let state = response.data.latlon.state;
          //let street = response.data.latlon.street;
          //let city = response.data.latlon.city;

          api
            .members({ latitude: lat, longitude: lng })
            .then(response => {
              const congressMembers = response.data.members;
              let memberIDs = congressMembers.map(member => {
                return member.id;
              });

              //let stateCode = congressMembers[0].state

              this.setState({
                congressMembers,
                loading: false,
                showModal: true,
                zipError: false,
                //state: stateCode,
                allIDs: memberIDs
                //streetAddress: street,
                //city: city
              });
            })
            .catch(error => {
              console.log("MEMBERS ERROR ", error);
            });
        } else {
          this.setState({
            zipError: true
          });
        }
      })
      .catch(error => {
        console.log("LOCATION ERROR ", error);
        this.setState({
          zipError: true
        });
      });
  };

  setContactType = type => {
    this.setState({
      contactType: type
    });
  };

  clearZipError = () => {
    this.setState({
      zipError: false
    });
  };

  sendEmail = emailInfo => {
    // Do email sending logic here
    if (emailInfo.emailSubject.length < 1) {
      emailInfo.emailSubject = "Protect The Endangered Species Act";
    }

    this.setState({
      fullName: emailInfo.fullName,
      emailAddress: emailInfo.emailAddress,
      emailSentLoading: true
    });

    if (this.state.cid) {
      emailInfo.cid = this.state.cid;
      emailInfo.ms = this.state.ms;
    }
    emailInfo.actionName = "One Act for All - Email";
    emailInfo.actionType = "ETT";
    //emailInfo.streetAddress = this.state.streetAddress;
    //emailInfo.state = this.state.state;
    emailInfo.zip = this.state.zip;
    //emailInfo.city = this.state.city;
    let excludeList = R.difference(this.state.allIDs, this.state.selectedIDs);
    emailInfo.excludeList = excludeList.join(", ");
    api
      .contact(emailInfo)
      .then(response => {
        // console.log('SEND EMAIL RESPONSE ', response);
        this.setState(
          {
            emailedMembers: [
              ...this.state.selectedMembers,
              ...this.state.emailedMembers
            ],
            selectedMembers: [],
            contactType: "thanks",
            sendEmailInputError: false,
            emailSentLoading: false
          },
          function() {
            document
              .getElementById("title")
              .scrollIntoView({ behavior: "smooth" });
          }
        );
      })
      .catch(error => {
        // console.log('EMAIL SEND ERROR ', error.message);
        this.setState({
          sendEmailInputError: true
        });
      });
  };

  clearSelectedMembers = () => {
    this.setState({
      selectedMembers: [],
      sendEmailInputError: false
    });
  };

  doneCalling = () => {
    this.setState({
      calledMembers: [
        ...this.state.selectedMembers,
        ...this.state.calledMembers
      ],
      selectedMembers: [],
      contactType: "thanks"
    });
    let callInfo = {};

    if (this.state.emailAddress.length > 0) {
      if (this.state.cid) {
        callInfo.cid = this.state.cid;
        callInfo.ms = this.state.ms;
      }
      callInfo.fullName = this.state.fullName;
      callInfo.emailAddress = this.state.emailAddress;
      callInfo.actionName = "One Act for All - Call";
      callInfo.actionType = "CTT";
      //callInfo.streetAddress = this.state.streetAddress;
      //callInfo.state = this.state.state;
      callInfo.zip = this.state.zip;
      //callInfo.city = this.state.city;
      api.call(callInfo);
    }
  };

  setSelectedMembers = (index, memberID) => {
    let newArray;
    let newIDArray;
    if (isInArray(index, this.state.selectedMembers)) {
      newArray = this.state.selectedMembers.filter(item => item !== index);
    } else {
      newArray = [...this.state.selectedMembers, index];
    }

    if (isInArray(memberID, this.state.selectedIDs)) {
      newIDArray = this.state.selectedIDs.filter(item => item !== memberID);
    } else {
      newIDArray = [...this.state.selectedIDs, memberID];
    }

    this.setState({
      selectedMembers: newArray,
      selectedIDs: newIDArray
    });
  };

  closeModal = () => {
    this.setState({
      showModal: false,
      contactType: null,
      selectedMembers: []
    });
  };

  scrollToAnimals = () => {
    document
      .getElementById("animal-section")
      .scrollIntoView({ behavior: "smooth" });
  };
  render() {
    return (
      <div className={styles.appWrapper}>
        <ParallaxProvider>
          <OneActHeader />
          <TopTitle />
          <ZipWrapper
            findMembersByZip={this.findMembersByZip}
            zipError={this.state.zipError}
            findMembersByAddress={this.findMembersByAddress}
            clearZipError={this.clearZipError}
            scrollToAnimals={this.scrollToAnimals}
          />
          <TransitionGroup>
            {this.state.showModal && (
              <Modal
                closeModal={this.closeModal}
                contactType={this.state.contactType}
                zip={this.state.zip}
                state={this.state.state}
                setContactType={this.setContactType}
              >
                {this.state.contactType == "thanks" ? (
                  <div className={styles.thanks}>
                    <a
                      href="https://secure.ifaw.org/united-states/give-to-solve?ms=UONDG191107030&cid=7013k000001NeBV"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button title="Donate Now" color="#003973" />
                    </a>
                  </div>
                ) : (
                  ""
                )}

                <Members
                  members={this.state.congressMembers}
                  selectedMembers={this.state.selectedMembers}
                  emailedMembers={this.state.emailedMembers}
                  calledMembers={this.state.calledMembers}
                  setContactType={this.setContactType}
                  setSelectedMembers={this.setSelectedMembers}
                  contactType={this.state.contactType}
                />

                {this.state.contactType === "email" ? (
                  <Email
                    setContactType={this.setContactType}
                    clearSelectedMembers={this.clearSelectedMembers}
                    sendEmail={this.sendEmail}
                    sendEmailInputError={this.state.sendEmailInputError}
                    fullName={this.state.fullName}
                    emailAddress={this.state.emailAddress}
                    emailSentLoading={this.state.emailSentLoading}
                  />
                ) : (
                  ""
                )}
                {this.state.contactType === "call" ? (
                  <Call
                    setContactType={this.setContactType}
                    doneCalling={this.doneCalling}
                  />
                ) : (
                  ""
                )}
              </Modal>
            )}
          </TransitionGroup>
          <TopSection />
          <Timeline />
          <ThreeColumns />
          <CarouselWrapper
            ref="AnimalSection"
            scrollToAnimals={this.scrollToAnimals}
          />
          <Act />
          <ImageCallout />
          <CTA />
          <OneActFooter />
        </ParallaxProvider>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js